export const NOTIFICATION_DRAWER_FILTER = {
  ALL: 'all',
  UNREAD: 'unread',
} as const
